import React, { useState } from "react";
import { Link } from "react-router-dom";
import AnimatedNumber from "animated-number-react";
import bgeleven from "../../assets/images/background/bg-bennies.png";
import signatureone from "../../assets/images/resource/cheff.png";
import aboutimgone from "../../assets/images/resource/about-image-1.jpg";

function Aboutsec() {
    const [Video, setVideo] = useState();

    return (
        <>
            <section className="about-section">
                <div className="left-bg">
                    <img src={bgeleven} alt="" title="" />
                </div>
                <div className="right-bg">
                    <img src={bgeleven} alt="" title="" />
                </div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle">
                            <span>who we are</span>
                        </div>

                        <div className="pattern-image">
                            <img
                                src={
                                    require("../../assets/images/icons/separator.svg")
                                        .default
                                }
                                alt="mySvgImage"
                            />
                        </div>

                        <h5>
                            In the early 80s, Jean François and Sylvie journeyed
                            from Montreal, Quebec, to Alberta, spending some
                            time in Edmonton before finding their forever home
                            in the charming town of Canmore. By 1990, their
                            dream came to life with the opening of Chez
                            François.
                        </h5>
                        <br/>
                        <h5>
                            Inspired by the traditional French & Québécois
                            dishes our children adored, our menu is crafted with
                            love and rooted in family tradition. As a
                            family-owned and operated restaurant, we’re proud to
                            bring a little piece of Quebec to the heart of the
                            Rockies.
                        </h5>
                        <br/>
                        <h5>
                            Whether you're passing through or staying awhile,
                            come join us at Chez François and be part of our
                            family story.
                        </h5>
                    </div>
                    <div className="row clearfix">
                        <div className="about-block content-block col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div
                                className="inner-box wow fadeInUp"
                                data-wow-duration="1500ms"
                                data-wow-delay="0ms"
                            >
                                <div className="text">
                                    François has kept his recipes for years,
                                    ensuring his staples are homemade with
                                    high-quality ingredients. Our hollandaise is
                                    made fresh by hand daily and is sure to
                                    ‘wow’ you. We also make our own lamb
                                    sausages, duck liver paté, and creton.
                                </div>
                                <div className="signature">
                                    <img src={signatureone} alt="" title="" />
                                </div>
                                <div className="author">
                                    Jean François - chef
                                </div>
                            </div>
                        </div>

                        <div className="about-block image-block col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div
                                className="inner-box wow fadeInUp"
                                data-wow-duration="1500ms"
                                data-wow-delay="300ms"
                            >
                                <div className="image">
                                    <img src={aboutimgone} alt="" />
                                </div>
                            </div>
                        </div>

                        <div className="about-block info-block col-xl-4 col-lg-4 col-md-12 col-sm-12">
                            <div
                                className="inner-box wow fadeInUp"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <ul className="info">
                                    <li>
                                        <strong>Breakfast - Lunch</strong>Monday
                                        to Friday <br />7 AM TO 2:30 PM
                                    </li>
                                    <li>
                                        <strong>Breakfast - Lunch</strong>
                                        Saturday, Sunday <br />7 AM TO 3:00 PM
                                    </li>
                                    <li className="separator">
                                        <span></span>
                                    </li>
                                    <li>
                                        <strong>Contact Us</strong>
                                        <span className="address">
                                            1716 BOW VALLEY TRAIL,CHATEAU
                                            CANMORE QUALITY RESORT,CANMORE T1W
                                            2X3
                                        </span>{" "}
                                        <Link to="tel:+1-403-678-6111">
                                            +1 403 678 6111
                                        </Link>{" "}
                                        <br />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="fact-counter">
                        <div className="row clearfix">
                            <div className="fact-block col-lg-4 col-md-6 col-sm-12">
                                <div className="inner clearfix">
                                    <div className="fact-count">
                                        <div className="count-box">
                                            <AnimatedNumber
                                                className="count-text"
                                                value={70}
                                                duration={2000}
                                                formatValue={(v) =>
                                                    Math.round(v)
                                                }
                                            />
                                            <i>+</i>
                                        </div>
                                    </div>
                                    <div className="fact-title">Menu Items</div>
                                </div>
                            </div>
                            <div className="fact-block col-lg-4 col-md-6 col-sm-12">
                                <div className="inner clearfix">
                                    <div className="fact-count">
                                        <div className="count-box">
                                            <AnimatedNumber
                                                className="count-text"
                                                value={2500}
                                                duration={1500}
                                                formatValue={(v) =>
                                                    Math.round(v)
                                                }
                                            />
                                            <i>+</i>
                                        </div>
                                    </div>
                                    <div className="fact-title">
                                        BREAKFASTS WEEKLY
                                    </div>
                                </div>
                            </div>
                            <div className="fact-block col-lg-4 col-md-6 col-sm-12">
                                <div className="inner clearfix">
                                    <div className="fact-count">
                                        <div className="count-box">
                                            <AnimatedNumber
                                                className="count-text"
                                                value={40}
                                                duration={1000}
                                                formatValue={(v) =>
                                                    Math.round(v)
                                                }
                                            />
                                            <i>+</i>
                                        </div>
                                    </div>
                                    <div className="fact-title">
                                        Years of Passion
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Aboutsec;
